import { useSelector } from 'react-redux';

export const useGetCurrentClerkType = () => {
	const { clerks, jurisdiction } = useSelector((state) => state.user);

	const clerkType = clerks?.find((data) => data.clerkId === jurisdiction)?.clerkType || '';

	return {
		clerkType
	};
};
